export default function (image_url) {
  let image = image_url ? image_url : "/default.png";
  if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_STRAPI_SERVER) {
    return process.env.NEXT_PUBLIC_STRAPI_SERVER + image;
  } else if (typeof process !== "undefined" && process.env.NEXT_PUBLIC_IMAGE_URL) {
    return process.env.NEXT_PUBLIC_IMAGE_URL + image;
  } else {
    return image;
  }
}
